import styled from "styled-components";

export const AppWrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    text-align: center;
`;



// WEBPACK FOOTER //
// ./src/App.sc.js